<!--
 * @Author: YuanYuan
 * @Date: 2024-02-06 10:45:45
 * @LastEditTime: 2025-07-25 17:03:30
 * @description: 请求数
-->
<template>
  <div>
    <el-row :gutter="16">
      <el-col v-bind="$const['Common/SearchCol']">
        <QuerySelect
          v-model="searchForm.groupId"
          v-loading="groupLoading"
          :data="groupOptions"
          :label="$t('common.domainGroup')"
          :all-label="$t('common.allDomainGroups')"
          :all-value="-1"
          label-key="groupName"
          value-key="groupId"
          @change="queryDomainOptions" />
      </el-col>
      <el-col v-bind="$const['Common/SearchCol']">
        <QuerySelectSearch
          v-model="searchForm.domains"
          v-loading="domainLoading"
          :data="domainOptions"
          label-key="domain"
          value-key="domain"
          :label="$t('common.domain')" />
      </el-col>
      <el-col v-bind="$const['Common/SearchCol']">
        <el-button @click="queryHandler" type="primary">{{$t('common.query')}}</el-button>
      </el-col>
    </el-row>
    <LineChart :options="lineChartData" v-loading="loading" />
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, reactive, onMounted, watch, toRefs } from 'vue'
import LineChart from '@/components/echarts/Line.vue'
import { useDomainGroups } from '@/utils/hooks'
import { beijingTime2TerminalTime } from '@/utils/time'
import { assign } from 'lodash-es'

const $vm = getCurrentInstance().proxy

const props = defineProps({
  topParams: {
    type: Object,
    default: () => ({
      packageId: '',
      beijingStartTime: '',
      beijingEndTime: ''
    })
  }
})
const { topParams } = toRefs(props)

const searchForm = reactive({
  groupId: -1,
  domains: []
})
const groupLoading = ref(false)
const groupOptions = ref([])
const domainOptions = ref([])
const domainLoading = ref(false)
let lineChartData = reactive({
  xAxis: {
    data: []
  },
  series: []
})
const loading = ref(false)

const queryHandler = () => {
  loading.value = true
  $vm.$api['usage/requestsQuery']({
    requestNum_select: searchForm.domains.join(','),
    package_id: topParams.value.packageId,
    begin_time: topParams.value.beijingStartTime,
    end_time: topParams.value.beijingEndTime,
    groupId: searchForm.groupId
  }).then(res => {
    if (res?.code === 200 && res?.data?.length) {
      lineChartData = assign(lineChartData, {
        xAxis: {
          data: res.data.map(n => beijingTime2TerminalTime(n.time))
        },
        series: [
          { data: res.data.map(n => n.value), name: $vm.$t('usage.requests') }
        ]
      })
    }
  }).finally(() => (loading.value = false))
}

const queryDomainOptions = () => {
  if (topParams.value.packageId) {
    domainLoading.value = true
    $vm.$api['usage/reqDomains']({
      packageId: topParams.value.packageId,
      startTime: topParams.value.beijingStartTime,
      endTime: topParams.value.beijingEndTime,
      groupId: searchForm.groupId
    }).then(res => {
      if (res?.code === 200 && res?.data?.length) {
        domainOptions.value = res.data.map(n => ({ domain: n }))
        if (searchForm.domains.length) {
          // 保留之前选择的且仍在新数据中存在的域名
          searchForm.domains = searchForm.domains.filter(n => res.data.includes(n))
        } else {
          searchForm.domains = res.data
        }
        queryHandler()
      } else {
        domainOptions.value = []
        searchForm.domains = []
        queryHandler()
      }
    }).finally(() => (domainLoading.value = false))
  }
}

watch(() => topParams.value, () => {
  queryDomainOptions()
}, { deep: true, immediate: true })

const getDomainGroupOptions = () => {
  groupLoading.value = true
  useDomainGroups().then(data => {
    groupOptions.value = data
  }).finally(() => (groupLoading.value = false))
}

onMounted(() => {
  getDomainGroupOptions()
})
</script>
